import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';
import EditAmbassadorProfile from "./EditAmbassadorProfile";

const ViewAmbassadorProfile = ({uid,userLoggedInRoles, userDetails}) => {

    const [toggles, setToggles] = useState({
        AmbassadorMainDetails: true,
        ambassadorMoreDetails: true,
        AmbassadorBio: true,
        educationToggle: true,
        qnaToggle: true,
        contactInfo: true,
        socialMediaToggle: true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

    const[userAmbassadorAssets,setUserAmbassadorAssets] = useState([]);
    const[userSocailMediaAssets,setUserSocialMediaAssets] = useState([]);
    const[userCommonAssets,setUserCommonAssets] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');


const sections = [
  {
    key: "field_biography",
    keyToggle: "AmbassadorBio",
    title: "Biography",
    emptyText: "No biography content.",
    customClass: "" //  special styling
  },
  {
    key: "field_education",
    keyToggle: "educationToggle",
    title: "Education",
    emptyText: "No education info.",
    customClass: "" //  special styling
  },
  {
    key: "field_q_a",
    keyToggle: "qnaToggle",
    title: "Q&A",
    emptyText: "No education info.",
    customClass: "" //  special styling
  },
  {
    key: "field_how_to_contact_client",
    keyToggle: "contactInfo",
    title: "How to Contact",
    emptyText: "No contact info.",
    customClass: "" //  special styling
  }
];

const rightSectionFields = [
    { label: "Ambassador Slug", key: "field_ambassador_slug" },
    { label: "Show on Frontend", key: "field_show_on_frontend_ambassado" },
];

    const [activeView, setActiveView] = useState("view");

    const showView = () => {
        const newView = activeView === "view" ? "edit_ambassador" : "ambassador";
        setActiveView(newView);

        navigate(`/user/${uid}/${newView}`);
    };

  const location = useLocation();

    useEffect(() => {
    if (location.pathname.includes("/edit_ambassador")) {
        setActiveView("edit");
    } else {
        setActiveView("view");
    }
    }, [location.pathname]);

const successAmbassadorEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

useEffect(() => {
    if (successAmbassadorEditMessage) {
    setSuccessEditMessage(successAmbassadorEditMessage);
    getambassadordetails();
    window.history.replaceState({}, '');
    }
}, [successEditMessage, location.state]);

const ambassadorSportFocusField = userAmbassadorAssets?.find(
    (item) => item.key === "field_sports_focus"
);

const ambassadorSportlist = ambassadorSportFocusField?.full_value
    ? ambassadorSportFocusField.full_value.split(",")
    : [];

const transformData = (dataArray) => {
    return dataArray.reduce((acc, item) => {
        if (item.date || item.time) {
        acc[item.key] = {
            date: item.date,
            time: item.time
        };
        } else {
        acc[item.key] = item.full_value ?? item.value ?? null;
        }
        return acc;
    }, {});
};

const backEndData = transformData(userAmbassadorAssets);

const mergedData = {
    ...backEndData,
    ...userCommonAssets
};

    async function getambassadordetails() { 
    
        if(uid!='') {
            try {
                setIsLoading(true);
            const response = await fetch(
            app_url+'viewprofile/getambassadordetails?uid='+uid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
            )
            const responsedata = await response.json();
            if(responsedata.data.result === "Success") {
            //uid = responsedata.data.user.drupal_uid;
                setUserAmbassadorAssets(responsedata.data.user_ambassador_assets || []);
                setUserSocialMediaAssets(responsedata.data.user_social_media_assets || []);
                setUserCommonAssets(responsedata.data.user_common_assets || {});
            }
            }  catch (error) {
            console.error('Error fetching data:', error);
            } finally {
            setIsLoading(false);
            }
        }
    }

    useEffect(() => {
    const promises = [
        getambassadordetails()
    ];

    Promise.all(promises)
        .then(() => {
        setIsLoading(false);
        })
        .catch(error => {
        console.error(error);
        // Handle error
        });
    }, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                <> 
                {activeView === "view" ? (
                <div>
                    <div className='viewtab-top-section'>

                        {successEditMessage && (
                            <div className="set-message-done" style={{marginBottom: "5px"}}>
                                <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successEditMessage}
                            </div>
                        )}
                        <div>
                            <div className="edit-agent-prof-editbtn">
                                <button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button>
                            </div>
                            <div 
                                className={`view-user-profile-section-header agent-section-header ${toggles["AmbassadorMainDetails"] ? "open" : ""}`}
                                style={{border: "0px", outline: "1px solid #bbb"}}
                            >
                                <div class="app-aspect-content" onClick={() => handleToggle("AmbassadorMainDetails")}>
                                    <div class="aspect-info">
                                        <span class="view-user-profile-section-heading"><strong>Ambassador Profile</strong></span>
                                    </div>
                                </div>
                                {toggles.AmbassadorMainDetails && (
                                    <div class="view-user-profile-section-body-container">
                                        <div class="view-user-profile-section-container user-profile-summary-table user-profile-details user-contact-info">

                                            <div className="edit-agent-prof-details" style={{justifyContent: "flex-start"}}>
                                                <div style={{flexShrink: "0"}}>
                                                    <div class="edit-agent-image">
                                                        {userDetails.picture ? (
                                                            <img
                                                                src={userDetails.picture}
                                                                width="100px"
                                                                height="100px"
                                                                alt="user"
                                                            />
                                                        ) : (
                                                            <div className="edit-agent-img-placeholder">
                                                                No Photo<br />Uploaded
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="agent-img-desc">100–1000px · png/jpg/gif</div>
                                                </div>
                                        
                                                <div class="agent-name-loc" style={{marginBottom:'2%', minWidth: "200px", maxWidth: "495px"}}>
                                                    <div class="user-name" style={{color:"#333333"}} >{userDetails.first_name} {userDetails.last_name}</div>
                                                    <div class="user-loc" style={{marginBottom:"15px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
                                                    {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</div>
                                                    <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Sports Focus</div>

                                                        <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                    {ambassadorSportlist.length > 0 ? (
                                                        ambassadorSportlist.map((item, index) => (
                                                        <span key={index} className="profile-applied-course-tags">
                                                            {item}
                                                        </span>
                                                        ))
                                                    ) : (
                                                        <span
                                                        className="profile-applied-course-tags"
                                                        style={{ color: "#999", fontStyle: "italic" }}
                                                        >
                                                        None selected
                                                        </span>
                                                    )}</span>

                                                </div>
                                            
                                                {/* <div className="agent-profile-right">
                                                    {rightSectionFields.map((item) => {
                                                        let value = mergedData?.[item.key];

                                                        if (item.key === "field_show_on_frontend_ambassado") {
                                                            return (
                                                                <div className="agent-profile-right-content" key={item.key}>
                                                                    <div className="agent-profile-right-content-label">
                                                                        {item.label}
                                                                    </div>
                                                                    <div className="agent-profile-right-content-value">
                                                                        {Number(value) === 1 ? "Yes" : "No"}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <div className="agent-profile-right-content" key={item.key}>
                                                                <div className="agent-profile-right-content-label">
                                                                    {item.label}
                                                                </div>
                                                                <div className="agent-profile-right-content-value">
                                                                    {value || "-"}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{clear: "both"}}></div>
                        </div>
                    </div>

                    <div className={`view-user-profile-section-header ${toggles["ambassadorMoreDetails"] ? "open" : ""}`}>
                        
                        <div className="app-aspect-content" onClick={() => handleToggle("ambassadorMoreDetails")}>
                            <div className="aspect-info">
                                <span className="view-user-profile-section-heading">
                                    <strong>Ambassador Details</strong>
                                </span>
                            </div>
                        </div>

                        {toggles.ambassadorMoreDetails && (
                            <div className="view-user-profile-section-body-container">
                                <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                                    <div className="opinion-header profile_summary view-user-profile-section-content">

                                        <table className="user-profile-summary-table">
                                            <tbody>
                                                {[
                                                    ["field_ambassador_slug", "Slug"],
                                                ].map(([key, label]) => {
                                                    let value = mergedData?.[key];

                                                    // if (!value) return null;

                                                    return (
                                                        <tr key={key}>
                                                            <td className="user-profile-summary-row" valign="top">
                                                                <span className="user-profile-label">
                                                                    {label}:&nbsp;
                                                                </span>
                                                            </td>

                                                            <td className="user-profile-summary-row" valign="top">
                                                                <span className="user-profile-value">
                                                                    {value || "-"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                                {/* Status & Visibility - Showing all fields with Yes/No status */}
                                                {userAmbassadorAssets
                                                    .filter(item => 
                                                        ['field_show_on_frontend_ambassado'].includes(item.key)
                                                    )
                                                    .map((item) => (
                                                        <tr key={item.key}>
                                                            <td className="user-profile-summary-row">
                                                                <span className="user-profile-label">{item.label}:&nbsp;</span>
                                                            </td>
                                                            <td className="user-profile-summary-row">
                                                                <span className="user-profile-value">
                                                                    {/* Ternary: If value is 1 show Yes, otherwise show No */}
                                                                    {Number(item.value) === 1 ? "Yes" : "No"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {sections.map((section) => {
                        //   const content = backEndData?.[section.key];
                        const content = mergedData?.[section.key];

                        return (
                            <div
                            key={section.keyToggle}
                            className={`view-user-profile-section-header ${
                                toggles[section.keyToggle] ? "open" : ""
                            }`}
                            >
                            <div
                                className="app-aspect-content"
                                onClick={() => handleToggle(section.keyToggle)}
                            >
                                <div className="aspect-info">
                                <span className="view-user-profile-section-heading">
                                    <strong>{section.title}</strong>
                                </span>
                                </div>
                            </div>

                            {toggles[section.keyToggle] && (
                                <div className="view-user-profile-section-body-container">
                                <div
                                    className={`opinion-header profile_summary view-agent-profile-section-content ${
                                    section.customClass || ""
                                    }`}
                                >
                                    {content ? (
                                    <div
                                        // className="agent-richtext-placeholder"
                                        className={`agent-richtext-placeholder ${section.customClass2 || ""}`}
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    />
                                    ) : (
                                    <div className="agent-richtext-placeholder empty">
                                        {section.emptyText}
                                    </div>
                                    )}
                                </div>
                                </div>
                            )}
                            </div>
                        );
                    })}

                    <div className={`view-user-profile-section-header ${toggles["socialMediaToggle"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("socialMediaToggle")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Social Media</strong></span>
                            </div>
                        </div>
                        {toggles.socialMediaToggle && (
                        <div className="view-user-profile-section-body-container">
                            {userSocailMediaAssets && Object.keys(userSocailMediaAssets).some(key => userSocailMediaAssets[key]) ? (
                            <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                                <div className="opinion-header profile_summary view-user-profile-section-content">
                                <table className="user-profile-summary-table">
                                    <tbody>
                                    {[
                                        ['field_instagram_url', 'Instagram URL'],
                                        ['field_instagram_handle', 'Instagram Handle'],
                                        ['field_facebook_url', 'Facebook URL'],
                                        ['field_facebook_handle', 'Facebook Handle'],
                                        ['field_twitter_url', 'Twitter URL'],
                                        ['field_user_youtube_url', 'YouTube URL'],
                                        ['field_linkedin_url', 'LinkedIn URL'],
                                        ['field_linkedin_handle', 'LinkedIn Handle'],
                                    ].map(([key, label]) => {
                                        const value = userSocailMediaAssets[key];
                                        // Skip empty values
                                        if (!value) return null;
                                        return (
                                        <tr key={key}>
                                            <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-label">
                                                {label}:&nbsp;
                                            </span>
                                            </td>
                                            <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-value">
                                                {value || "-"}
                                            </span>
                                            </td>
                                        </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                            ) : (
                            <div className="opinion-header profile_summary view-agent-profile-section-content">
                                <div className="agent-richtext-placeholder empty">
                                No social media content.
                                </div>
                            </div>
                            )}
                        </div>
                        )}
                    </div>

            </div>
        ) : (<>
            <EditAmbassadorProfile uid={uid} userLoggedInRoles={userLoggedInRoles} userAmbassadorAssets={userAmbassadorAssets} userCommonAssets={userCommonAssets} userSocailMediaAssets={userSocailMediaAssets} picture={userDetails.picture} />
        </>)}

        </>
        )}
        </>
    );
};

export default ViewAmbassadorProfile;